import React, { useState } from 'react';
import styled from 'styled-components';
import { Section, Title } from './Styled';
import { theme } from '../theme';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

interface Project {
  img: string;
  title: string;
  desc: string;
}

const GalleryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;



const ImageFrame = styled.div`
  width: 700px;
  height: 400px;
  background: ${theme.colors.black};
  border-radius: 16px;
  box-shadow: 0 4px 32px rgba(49,236,86,0.10);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;

  @media (max-width: 900px) {
    width: 98vw;
    height: 45vw;
    min-height: 220px;
    max-width: 100vw;
  }
  @media (max-width: 600px) {
    height: 40vw;
    min-height: 120px;
  }
`;


const GalleryImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const GalleryDesc = styled.div`
  color: ${theme.colors.white};
  background: rgba(24,26,27,0.85);
  padding: 1.2rem 2rem;
  border-radius: 8px;
  font-size: 1.1rem;
  margin-bottom: 1.2rem;
  text-align: center;
  max-width: 700px;
`;

const NavButtons = styled.div`
  display: flex;
  gap: 2rem;
  margin-bottom: 1.5rem;
`;

const ArrowButton = styled.button`
  background: ${theme.colors.green};
  color: ${theme.colors.black};
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  font-size: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(49,236,86,0.10);
  transition: background 0.2s;
  &:hover {
    background: ${theme.colors.darkGreen};
    color: ${theme.colors.white};
  }
`;
const Gallery: React.FC = () => {
  const { language } = useLanguage();
  const t = translations.gallery[language];
  const [current, setCurrent] = useState(0);
  const projects: Project[] = t.projects.map((project) => ({
    img: project.img,
    title: project.title,
    desc: project.desc,
  }));
  const total = t.projects.length;

  const prev = () => setCurrent((c) => (c === 0 ? total - 1 : c - 1));
  const next = () => setCurrent((c) => (c === total - 1 ? 0 : c + 1));

  return (
    <Section id="gallery" bg={theme.colors.blackBg}>
      <Title>{t.title}</Title>
      <GalleryContainer>
      <ImageFrame>
          <GalleryImage src={projects[current].img} alt={projects[current].title} />
        </ImageFrame>
        <GalleryDesc>
          <strong>{projects[current].title}</strong>: {projects[current].desc}
        </GalleryDesc>
        <NavButtons>
          <ArrowButton aria-label="Previous" onClick={prev}>&larr;</ArrowButton>
          <ArrowButton aria-label="Next" onClick={next}>&rarr;</ArrowButton>
        </NavButtons>
        <div style={{ color: theme.colors.green, fontSize: '1rem' }}>
          {current + 1} / {total}
        </div>
      </GalleryContainer>
    </Section>
  );
};

export default Gallery;

